module.exports = __webpack_public_path__ + "static/media/3-1.92f81c17.jpg";